import React from 'react';
import cx from 'classnames';

import css from './desktopMaxWidthContainer.module.sass';

interface Props {
  className?: string;
  noPadding?: boolean;
}

export const DesktopMaxWidthContainer: React.FC<Props> = ({
  className,
  noPadding,
  children,
}) => {
  return (
    <div
      className={cx(css.root, className || '', { [css.noPadding]: noPadding })}
    >
      {children}
    </div>
  );
};
